import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "./home.css";

export const HomePage = ({
  fetchHomeProducts,
  home,
  isLoading,
  addToCart,
  addToWishlist,
  removeToWishlist,
  isAdded,
  isLoggedIn,
}) => {
  useEffect(() => {
    fetchHomeProducts();
  }, []);
  const navigate = useNavigate();

  useEffect(() => {
    if (!sessionStorage.getItem("modalShown")) {
      window.onload = () => {
        const modalElement = document.getElementById("staycationSaleModal");
        const myModal = new window.bootstrap.Modal(modalElement, {
          backdrop: false, // ✅ Disables the backdrop completely
          keyboard: false, // Optional: Prevent closing with Escape key
        });
        myModal.show();
        sessionStorage.setItem("modalShown", "Yes");
      };
    }
  }, []);

  return (
    <>
      <div
        className="modal fade"
        id="staycationSaleModal"
        tabIndex="-1"
        aria-labelledby="staycationSaleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content" style={{ background: "#fff" }}>
            <div class="modal-header">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/logo.jpg`}
                width="100px"
              />
              <button
                type="button"
                class="close-btn cross"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                &times;
              </button>
            </div>
            <div class="modal-body">
              <h5 class="modal-title" id="staycationSaleModalLabel">
                Don’t miss out on 20% off sitewide during the Bhabhuti's Sale.
                Find your code.
              </h5>
            </div>
          </div>
        </div>
      </div>
      <div
        id="carouselExampleIndicators"
        className="carousel slide"
        data-bs-ride="carousel"
        data-bs-interval="3000"
      >
        <div className="carousel-indicators">
          <button
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide-to="0"
            className="active"
            aria-current="true"
            aria-label="Slide 1"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide-to="1"
            aria-label="Slide 2"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide-to="2"
            aria-label="Slide 3"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide-to="3"
            aria-label="Slide 4"
          ></button>
        </div>
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/banner1.jpg`}
              className="d-block w-100"
              alt="..."
            />
          </div>
          <div className="carousel-item">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/bhawaninew.png`}
              className="d-block w-100"
              alt="..."
            />
          </div>
          <div className="carousel-item">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/banner3.jpg`}
              className="d-block w-100"
              alt="..."
            />
          </div>
          <div className="carousel-item">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/banner4.jpg`}
              className="d-block w-100"
              alt="..."
            />
          </div>
        </div>
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
      <section className="under-banner">
        <p>
          <b> Bhabhuti Herbals </b>is committed to enhancing your well-being
          with cutting-edge nutritional supplements made from the finest, most
          effective ingredients. We prioritize both quality and accessibility,
          delivering premium products without the inflated costs seen
          elsewhere—so you can pursue wellness confidently and affordably.
        </p>
      </section>
      {Array.isArray(home?.featured) && home?.featured?.length > 0 && (
        <section
          className="products"
          style={{ maxWidth: "1350px", margin: "auto" }}
        >
          <div className="container">
            <h3 className="pro-head">Our Products</h3>
            <div className="row">
              {home?.featured?.map((x) => {
                let benifits = x?.benifits?.replace(/'/g, '"').trim();
                benifits = JSON.parse(benifits || "[]");
                return (
                  <div class="col-12 col-md-6 col-lg-4 mb-4" key={x?.id}>
                    <div
                      class="card"
                      onClick={() => navigate(`/product/${x?.slug}`)}
                    >
                      <h3 class="product-title text-center">{x?.name}</h3>
                      <div class="product type-product flex-grow-1 d-flex flex-column">
                        <div class="product-wrapper d-flex flex-column flex-md-row">
                          <div class="col-12 col-md-6 benefits-section">
                            <ul class="list-group">
                              {Array.isArray(benifits) &&
                                benifits.map((b, i) => {
                                  return (
                                    <li className="list-group-item" key={i}>
                                      <i className="fa-solid fa-check"></i>
                                      {b}
                                    </li>
                                  );
                                })}
                            </ul>
                          </div>
                          <div class="col-12 col-md-6 product-image">
                            <img
                              src={`${process.env.REACT_APP_ASSET_URL}/${x?.image}`}
                              alt={x?.name}
                            />
                            <div className="icon-overlay">
                              <i
                                className="fa-solid fa-cart-shopping"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  e.preventDefault();
                                  addToCart({ ProductId: x?.id, quantity: 1 });
                                }}
                              ></i>
                              {Array.isArray(x?.Wishlists) &&
                                x?.Wishlists?.length > 0 ? (
                                <i
                                  className="fa fa-heart"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    isLoggedIn
                                      ? removeToWishlist(x?.Wishlists?.[0]?.id)
                                      : toast.info("Please login first.", {
                                        position: toast.POSITION.TOP_RIGHT,
                                        theme: "colored",
                                      });
                                  }}
                                ></i>
                              ) : (
                                <i
                                  className="fa-regular fa-heart"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    isLoggedIn
                                      ? addToWishlist({ ProductId: x?.id })
                                      : toast.info("Please login first.", {
                                        position: toast.POSITION.TOP_RIGHT,
                                        theme: "colored",
                                      });
                                  }}
                                ></i>
                              )}
                            </div>
                          </div>
                        </div>
                        <div class="product-price my-2 text-center">
                          <ins>
                            <span>
                              <strong>Retail Price:</strong>&nbsp;₹{" "}
                              {x?.currentPrice}
                            </span>
                          </ins>
                        </div>
                        <div class="product-info text-center">
                          <div class="row">
                            <div class="col-12 col-md-6 mb-2">
                              <a
                                href="#"
                                class="btn btn-outline-secondary w-100"
                              >
                                <i class="fa-solid fa-play"></i> Learn More
                              </a>
                            </div>
                            <div class="col-12 col-md-6 mb-2">
                              <a
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  addToCart({ ProductId: x?.id, quantity: 1 });
                                }}
                                class="btn btn-success w-100"
                              >
                                <i class="fa-solid fa-cart-shopping"></i> Order
                                Now
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      )}
      {Array.isArray(home?.best) && home?.best?.length > 0 && (
        <section
          className="products best-product"
          style={{ maxWidth: "1350px", margin: "auto" }}
        >
          <div className="container">
            <p className="pro-p">Top Products</p>
            <h3 className="pro-head">Best Selling Products</h3>

            <div className="row">
              {home?.best?.map((x) => {
                let benifits = x?.benifits?.replace(/'/g, '"').trim();
                benifits = JSON.parse(benifits || "[]");
                return (
                  <div class="col-12 col-md-6 col-lg-4 mb-4" key={x?.id}>
                    <div
                      class="card"
                      onClick={() => navigate(`/product/${x?.slug}`)}
                    >
                      <h3 class="product-title text-center">{x?.name}</h3>
                      <div class="product type-product flex-grow-1 d-flex flex-column">
                        <div class="product-wrapper d-flex flex-column flex-md-row">
                          <div class="col-12 col-md-6 benefits-section">
                            <ul class="list-group">
                              {Array.isArray(benifits) &&
                                benifits.map((b, i) => {
                                  return (
                                    <li className="list-group-item" key={i}>
                                      <i className="fa-solid fa-check"></i>
                                      {b}
                                    </li>
                                  );
                                })}
                            </ul>
                          </div>
                          <div class="col-12 col-md-6 product-image">
                            <img
                              src={`${process.env.REACT_APP_ASSET_URL}/${x?.image}`}
                              alt={x?.name}
                            />
                            <div className="icon-overlay">
                              <i
                                className="fa-solid fa-cart-shopping"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  e.preventDefault();
                                  addToCart({ ProductId: x?.id, quantity: 1 });
                                }}
                              ></i>
                              {Array.isArray(x?.Wishlists) &&
                                x?.Wishlists?.length > 0 ? (
                                <i
                                  className="fa fa-heart"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    isLoggedIn
                                      ? removeToWishlist(x?.Wishlists?.[0]?.id)
                                      : toast.info("Please login first.", {
                                        position: toast.POSITION.TOP_RIGHT,
                                        theme: "colored",
                                      });
                                  }}
                                ></i>
                              ) : (
                                <i
                                  className="fa-regular fa-heart"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    isLoggedIn
                                      ? addToWishlist({ ProductId: x?.id })
                                      : toast.info("Please login first.", {
                                        position: toast.POSITION.TOP_RIGHT,
                                        theme: "colored",
                                      });
                                  }}
                                ></i>
                              )}
                            </div>
                          </div>
                        </div>
                        <div class="product-price my-2 text-center">
                          <ins>
                            <span>
                              <strong>Retail Price:</strong>&nbsp;₹{" "}
                              {x?.currentPrice}
                            </span>
                          </ins>
                        </div>
                        <div class="product-info text-center">
                          <div class="row">
                            <div class="col-12 col-md-6 mb-2">
                              <a
                                href="#"
                                class="btn btn-outline-secondary w-100"
                              >
                                <i class="fa-solid fa-play"></i> Learn More
                              </a>
                            </div>
                            <div class="col-12 col-md-6 mb-2">
                              <a
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  addToCart({ ProductId: x?.id, quantity: 1 });
                                }}
                                class="btn btn-success w-100"
                              >
                                <i class="fa-solid fa-cart-shopping"></i> Order
                                Now
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      )}
      <div className="container my-5">
        <div className="row features g-3">
          <div className="col-lg-3 col-md-6 col-sm-12">
            <div className="quality-card text-center">
              <div className="img-div">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/mq.png`}
                  alt="Manage Quality Icon"
                  className="img-fluid"
                />
              </div>
              <div className="content">
                <h5>
                  <a href="service.html">Manage Quality</a>
                </h5>
                <span>Best Quality Guarantee</span>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-12">
            <div className="quality-card text-center">
              <div className="img-div">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/mq2.png`}
                  alt="Manage Quality Icon"
                  className="img-fluid"
                />
              </div>
              <div className="content">
                <h5>
                  <a href="service.html">Manage Quality</a>
                </h5>
                <span>Best Quality Guarantee</span>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-12">
            <div className="quality-card text-center">
              <div className="img-div">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/mq3.png`}
                  alt="Manage Quality Icon"
                  className="img-fluid"
                />
              </div>
              <div className="content">
                <h5>
                  <a href="service.html">Manage Quality</a>
                </h5>
                <span>Best Quality Guarantee</span>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-12">
            <div className="quality-card text-center">
              <div className="img-div">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/mq4.png`}
                  alt="Manage Quality Icon"
                  className="img-fluid"
                />
              </div>
              <div className="content">
                <h5>
                  <a href="service.html">Manage Quality</a>
                </h5>
                <span>Best Quality Guarantee</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
